import { defineMessages } from 'react-intl';

export const pageMessages = defineMessages({
  managePageTitle: {
    id: 'preference-center-manage-page-title',
    defaultMessage: 'Email preferences',
  },
  managePageSubtitle: {
    id: 'preference-center-manage-page-subtitle',
    defaultMessage: 'Choose what you’d like to hear from us about. You can change this anytime.',
  },
  managingFor: {
    id: 'preference-center-managing-for',
    defaultMessage: 'Managing preferences for {email}',
  },
  unsubscribeAllButton: {
    id: 'preference-center-unsubscribe-all-button',
    defaultMessage: 'Unsubscribe from all marketing emails',
  },
});

export const layoutMessages = defineMessages({
  backToMollie: {
    id: 'preference-center-footer-back-to-mollie',
    defaultMessage: 'Back to mollie.com',
  },
  needHelp: {
    id: 'preference-center-footer-need-help',
    defaultMessage: 'Need help? Contact support',
  },
});

export const modalMessages = defineMessages({
  title: {
    id: 'preference-center-unsubscribe-all-modal-title',
    defaultMessage: 'Unsubscribe from all?',
  },
  body: {
    id: 'preference-center-unsubscribe-all-modal-body',
    defaultMessage:
      'You’ll stop receiving all marketing emails from Mollie. You can resubscribe at any time from this page.',
  },
  cancel: {
    id: 'preference-center-unsubscribe-all-modal-cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'preference-center-unsubscribe-all-modal-confirm',
    defaultMessage: 'Yes, unsubscribe',
  },
});

export const oneClickMessages = defineMessages({
  unsubscribedTitle: {
    id: 'preference-center-oneclick-unsubscribed-title',
    defaultMessage: 'You’re unsubscribed',
  },
  unsubscribedBody: {
    id: 'preference-center-oneclick-unsubscribed-body',
    defaultMessage: 'You won’t receive any more {category} emails from Mollie.',
  },
  resubscribedTitle: {
    id: 'preference-center-oneclick-resubscribed-title',
    defaultMessage: 'You’re resubscribed',
  },
  resubscribedBody: {
    id: 'preference-center-oneclick-resubscribed-body',
    defaultMessage: 'We’ve restored your subscription to {category} emails from Mollie.',
  },
  undoButton: {
    id: 'preference-center-oneclick-undo-button',
    defaultMessage: 'Undo',
  },
  manageAllLink: {
    id: 'preference-center-oneclick-manage-all-link',
    defaultMessage: 'Manage all email preferences',
  },
});

export const categoryMessages = defineMessages({
  businessInsightsName: {
    id: 'preference-center-category-business-insights-name',
    defaultMessage: 'Business Insights',
  },
  businessInsightsDescription: {
    id: 'preference-center-category-business-insights-description',
    defaultMessage: 'Industry research, benchmarks, and growth tips for your business.',
  },
  capitalName: {
    id: 'preference-center-category-capital-name',
    defaultMessage: 'Capital',
  },
  capitalDescription: {
    id: 'preference-center-category-capital-description',
    defaultMessage: 'Funding offers, eligibility updates, and Mollie Capital news.',
  },
  inPersonPaymentsName: {
    id: 'preference-center-category-in-person-payments-name',
    defaultMessage: 'In-person Payments',
  },
  inPersonPaymentsDescription: {
    id: 'preference-center-category-in-person-payments-description',
    defaultMessage: 'Updates on terminals, contactless, and selling face-to-face.',
  },
  newsAndEventsName: {
    id: 'preference-center-category-news-and-events-name',
    defaultMessage: 'News and Events',
  },
  newsAndEventsDescription: {
    id: 'preference-center-category-news-and-events-description',
    defaultMessage: 'Mollie company news, industry events, and webinars near you.',
  },
  paymentMethodsName: {
    id: 'preference-center-category-payment-methods-name',
    defaultMessage: 'Payment Methods',
  },
  paymentMethodsDescription: {
    id: 'preference-center-category-payment-methods-description',
    defaultMessage: 'New payment methods we’ve added and changes to existing ones.',
  },
  productsName: {
    id: 'preference-center-category-products-name',
    defaultMessage: 'Products',
  },
  productsDescription: {
    id: 'preference-center-category-products-description',
    defaultMessage: 'Product launches, feature releases, and roadmap updates.',
  },
  surveysAndFeedbackName: {
    id: 'preference-center-category-surveys-and-feedback-name',
    defaultMessage: 'Surveys and Feedback',
  },
  surveysAndFeedbackDescription: {
    id: 'preference-center-category-surveys-and-feedback-description',
    defaultMessage: 'Short surveys to help us improve Mollie.',
  },
});
